import { validate } from './validations'
import { build } from '../../../services/crudFactory'
import { Action } from '../../../services/actions.factory'
import apiCommand from '../../../services/api-command'
import apiPublic from '../../../services/api-public'
import { messageActions } from '../../../store/message'
import _ from 'lodash'

const BASE_PATH = '/lottustech/relatorios'
const crud = build(validate, BASE_PATH)
const prefix = 'crudPbIndicador'

const URL_CARTEIRINHA =
  'https://report.lottustech.com.br/jasperserver/flow.html?_flowId=viewReportFlow&reportUnit=/reports/interactive/BOMPASTOR/CartaoIndicacao&j_username=jasperlottus&j_password=11e727a0-dec1-4f16-86ae-42b1598c3124&nomeUsuario=Vandir+Fernando+Rezende&oidEmpresa=35&oidUsuario=17&oidPessoaFisica={{OID_PESSOA}}&decorate=no&output=html'
const newTypes = {
  RESET_FORM: `${prefix}resetForm`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.resetForm = () => {
  return {
    type: types.RESET_FORM,
  }
}

actions.executeCommand = (params) => {
  return (dispatch, getState) => {
    apiCommand
      .commandIndicador(params)
      .then((response) => {
        dispatch(messageActions.messageShowMessages(makeMessages(['Parceiro informado.'], 'success')))
        dispatch(actions.resetForm())
        const oidPessoa = parseInt(_.get(response, 'data[0].cadastrar_parceiro', null))
        if (_.isNumber(oidPessoa) && !_.isNaN(oidPessoa)) {
          const win = window.open(URL_CARTEIRINHA.replace('{{OID_PESSOA}}', oidPessoa), '_blank')
          win.focus()
          apiPublic.enviarEmailCartaoIndicacao({ oidPessoa, oidEmpresa: params.oidEmpresa })
        } else {
          dispatch(
            messageActions.messageShowMessages(makeMessages(['Ocorreu um erro executando o cadastro.'], 'error'))
          )
        }
      })
      .catch((error) => {
        if (error.response) {
          const messages = error.response.data
          dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
        }
      })
  }
}

const makeMessages = (messages, type) => {
  let sticky = false
  let summary = ''
  if (type === 'error') {
    summary = ''
    sticky = true
  } else if (type === 'warn') {
    summary = ''
    sticky = true
  }
  return messages.map((message) => {
    return {
      sticky: sticky,
      summary: summary,
      severity: type,
      detail: message,
    }
  })
}

export { types, actions }
